import styled from 'styled-components';

const Subtitle = styled.div`
  text-align: center;
`;

export default Subtitle;
